// extracted by mini-css-extract-plugin
export default {"columns":"Admins_columns__ha1B7"};